// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_wrapper {
    width: 100%;
    max-width: 1920px;
    bottom: 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    display: block;
    padding-top: 25px;
    padding-bottom: 25px;
    background-image: linear-gradient(90deg, #d1e0ff, #81aafd);
    position: fixed;
    z-index: 2;
    color: black;
}

.footer_items {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer_contacts {
    grid-column-gap: 25px;
    flex-wrap: nowrap;
    font-size: 24px;
    line-height: 24px;
    display: flex;
}

.footer_link {
    cursor: pointer;
    color: black;
    background-color: rgba(0, 0, 0, 0);
    align-items: flex-start;
    font-size: 24px;
    font-style: normal;
    line-height: 22px;
    text-decoration: none;
    display: flex;
    transition: 0.3s all;
}

.footer_phone {
    cursor: pointer;
    transition: 0.3s all;
}

.footer_phone:hover {
    opacity: 0.5;
    transition: 0.3s all;
}

.footer_link:hover {
    opacity: 0.5;
    transition: 0.3s all;
}

.footer_send {
    grid-column-gap: 25px;
    flex-wrap: nowrap;
    align-items: center;
    line-height: 24px;
    display: flex;
    justify-content: center;
    margin-right: 6%;
}

.footer_send_wrapper {
    position: absolute;
    width: 80px;
    height: 91%;
    right: 40px;
    z-index: 5;
    display: flex;
    align-items: center;
    border-top: 7px solid #4885ff;
    justify-content: center;
    background: #4885ff;
    transition: 0.3s all;
}

.footer_send_wrapper:hover {
    cursor: pointer;
    border-top: 7px solid blue;
    transition: 0.3s all;
}
.footer_send_wrapper:hover .svg_fill {
    transition: 0.3s all;
    fill: rgba(255, 255, 255, 0.479);
}

.svg_fill {
    fill: none;
    transition: 0.3s all;
}
`, "",{"version":3,"sources":["webpack://./src/widgets/footerbar/ui/Footerbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,oBAAoB;IACpB,0DAA0D;IAC1D,eAAe;IACf,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kCAAkC;IAClC,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,oBAAoB;AACxB;AACA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB","sourcesContent":[".footer_wrapper {\n    width: 100%;\n    max-width: 1920px;\n    bottom: 0;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    display: block;\n    padding-top: 25px;\n    padding-bottom: 25px;\n    background-image: linear-gradient(90deg, #d1e0ff, #81aafd);\n    position: fixed;\n    z-index: 2;\n    color: black;\n}\n\n.footer_items {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.footer_contacts {\n    grid-column-gap: 25px;\n    flex-wrap: nowrap;\n    font-size: 24px;\n    line-height: 24px;\n    display: flex;\n}\n\n.footer_link {\n    cursor: pointer;\n    color: black;\n    background-color: rgba(0, 0, 0, 0);\n    align-items: flex-start;\n    font-size: 24px;\n    font-style: normal;\n    line-height: 22px;\n    text-decoration: none;\n    display: flex;\n    transition: 0.3s all;\n}\n\n.footer_phone {\n    cursor: pointer;\n    transition: 0.3s all;\n}\n\n.footer_phone:hover {\n    opacity: 0.5;\n    transition: 0.3s all;\n}\n\n.footer_link:hover {\n    opacity: 0.5;\n    transition: 0.3s all;\n}\n\n.footer_send {\n    grid-column-gap: 25px;\n    flex-wrap: nowrap;\n    align-items: center;\n    line-height: 24px;\n    display: flex;\n    justify-content: center;\n    margin-right: 6%;\n}\n\n.footer_send_wrapper {\n    position: absolute;\n    width: 80px;\n    height: 91%;\n    right: 40px;\n    z-index: 5;\n    display: flex;\n    align-items: center;\n    border-top: 7px solid #4885ff;\n    justify-content: center;\n    background: #4885ff;\n    transition: 0.3s all;\n}\n\n.footer_send_wrapper:hover {\n    cursor: pointer;\n    border-top: 7px solid blue;\n    transition: 0.3s all;\n}\n.footer_send_wrapper:hover .svg_fill {\n    transition: 0.3s all;\n    fill: rgba(255, 255, 255, 0.479);\n}\n\n.svg_fill {\n    fill: none;\n    transition: 0.3s all;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
